import { useEffect, useState } from 'react'
import '../css/App.css'
import { AuthState } from '../store/auth'
import { sound } from '../util/sound'

interface Props {
  auth:             AuthState
  onLogout:         () => void
  onOpenSettings?:  () => void
  onOpenMyInfo?:    () => void
  /** 게임 중 여부 — true면 [내정보] 아이콘 비활성 (SEQ=10110 §7) */
  inGame?:          boolean
}

export default function NavBar({ auth, onLogout, onOpenSettings, onOpenMyInfo, inGame }: Props) {
  const [muted, setMuted] = useState<boolean>(sound.isMuted())

  // 외부에서 음소거 토글된 경우 동기화 안전망 (현 단계 직접 호출 경로는 NavBar 자체뿐이지만, 향후 키보드 단축키 등 확장 시)
  useEffect(() => {
    // No-op subscription placeholder — sound 모듈은 현재 listener API를 노출하지 않는다.
    // 필요 시 sound.subscribe(setMuted) 추가 가능.
  }, [])

  function handleToggleMute() {
    const next = sound.toggleMuted()
    setMuted(next)
  }

  const myInfoDisabled = !!inGame || !onOpenMyInfo

  return (
    <nav className="nav-bar">
      <h1 className="nav-logo">보드겜돌이</h1>
      <div className="nav-right">
        <span>
          <span className="nav-nickname">{auth.nickname}</span>
          <span className="muted"> 님</span>
        </span>
        <button
          className="nav-icon"
          onClick={handleToggleMute}
          title={muted ? '음소거 해제' : '음소거'}
          aria-label={muted ? '음소거 해제' : '음소거'}
        >
          {muted ? '🔇' : '🔊'}
        </button>
        {onOpenSettings && (
          <button
            className="nav-icon"
            onClick={onOpenSettings}
            title="설정"
            aria-label="설정"
          >
            ⚙
          </button>
        )}
        <button
          className="nav-icon"
          onClick={() => { if (!myInfoDisabled && onOpenMyInfo) onOpenMyInfo() }}
          title={myInfoDisabled ? '게임 중에는 변경할 수 없습니다' : '내 정보'}
          aria-label="내 정보"
          disabled={myInfoDisabled}
        >
          👤
        </button>
        <button className="nav-logout" onClick={onLogout}>로그아웃</button>
      </div>
    </nav>
  )
}
